export default __webpack_public_path__ + "f804473.png";